








import { Component, Vue, Prop } from 'vue-property-decorator';
import { isAndroid } from '@/common/utils/getPlaform';
import uploadOss from '@/common/utils/uploadOss';
import getUrlParam from '@/common/utils/getUrlParam';
import { AxiosPromiseData } from '@/common/interface';
import { SIZE_UNIT } from '@/common/constants/index';
import { validateImageType } from '@/common/utils';

@Component
export default class ImageUpload extends Vue {
  @Prop() index!: number;

  handleClick(): void {
    console.log(isAndroid(), 'isAndroid', window.WeixinJSBridge);
    if (window.WeixinJSBridge && !isAndroid()) {
      console.log('dansssss');
      window.wx.chooseImage({
        count: 1,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: (res: AxiosPromiseData) => {
          const localIds = res.localIds;
          window.wx.getLocalImgData({
            localId: localIds[0], // 图片的localID
            success: (res2: AxiosPromiseData) => {
              const localData = res2.localData; // localData是图片的base64数据
              const file = this.convertBase64UrlToBlob(localData);
              if (!file) {
                Vue.$toast.info('图片大小不能超过20M');
                return;
              }
              console.log(file, 'file----winodw');
              if (!validateImageType((file as Blob).type)) {
                Vue.$toast.info('只能上传jpg,png格式的图片');
                return;
              }
              const loading = window.weui.loading();
              const bizCode = Number(getUrlParam('id')) === 12500 ? 'AI_ADMISSIONS' : 'XM_SHOW';
              uploadOss.newUploadBlobToOSS(file as Blob, 'xmxImage' + new Date().valueOf(), (file as Blob).type, bizCode).then((res: any) => {
                loading.hide();
                if (this.index !== undefined) {
                  this.$emit('upload', res, this.index);
                } else {
                  this.$emit('upload', res);
                }
                window.scrollBy(0, 1);
              });
            }
          });
        }
      });
    } else {
      (this.$refs.inputFile as HTMLInputElement).click();
    }
  }

  uploadImg(event: Event): void {
    const qrcode = (event.target as HTMLInputElement).files![0];
    if (qrcode.size > 20 * SIZE_UNIT) {
      Vue.$toast.info('图片大小不能超过20M');
      return;
    }

    if (!validateImageType(qrcode.type)) {
      Vue.$toast.info('只能上传jpg,png格式的图片');
      return;
    }

    const prizePicture = document.getElementsByClassName('prize-picture');
    Array.from(prizePicture).forEach((picture: any) => {
      picture.value = '';
    });
    if (qrcode) {
      const loading = window.weui.loading();
      const bizCode = Number(getUrlParam('id')) === 12500 ? 'AI_ADMISSIONS' : 'XM_SHOW';
      uploadOss
        .newUploadBlobToOSS(qrcode as Blob, qrcode.name, qrcode.type, bizCode)
        .then((res: any) => {
          console.log(res, 'res');
          loading.hide();
          if (this.index !== undefined) {
            this.$emit('upload', res, this.index);
          } else {
            this.$emit('upload', res);
          }
          window.scrollBy(0, 1);
        })
        .catch(() => {
          loading.hide();
        });
    }
  }

  // base64转换成blol
  convertBase64UrlToBlob(urlData: string): Blob | boolean {
    const bytes = window.atob(urlData.split(',')[1]);
    const ab: ArrayBuffer = new ArrayBuffer(bytes.length);
    const ia: Uint8Array = new Uint8Array(ab);
    for (let i = 0; i < bytes.length; i++) {
      ia[i] = bytes.charCodeAt(i);
    }

    const blob = new Blob([ab], { type: 'image/png' });
    if (blob.size > 20 * SIZE_UNIT) {
      return false;
    }
    return new Blob([ab], { type: 'image/png' });
  }
}
